import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
  ErrorState,
  errorStateActionClassName,
} from '../../components/smart/ui/ErrorState';
import { SMART_ROUTES } from '../../constants';

export const ErrorPage = () => {
  const { t } = useTranslation('smart');

  return (
    <div className="smart-root">
      <ErrorState
        title={t('error.title')}
        message={t('error.unknown')}
        action={
          <Link to={SMART_ROUTES.HOME} className={errorStateActionClassName}>
            {t('error.goHome')}
          </Link>
        }
      />
    </div>
  );
};

/** Claim / network fail with no recovery CTA (parity with live ClaimFailScreen). */
export const ClaimFailPage = () => {
  const { t } = useTranslation('smart');

  return (
    <div className="smart-root">
      <ErrorState
        title={t('error.title')}
        message={t('error.claimNetworkExample')}
      />
    </div>
  );
};

/** Dead link with partner exit CTA. */
export const ClaimFailReturnPage = () => {
  const { t } = useTranslation('smart');

  return (
    <div className="smart-root">
      <ErrorState
        title={t('error.linkExpired')}
        message={t('error.linkExpiredMessage')}
        action={
          <button type="button" className={errorStateActionClassName}>
            {t('error.returnToApp')}
          </button>
        }
      />
    </div>
  );
};
